export default {
  layers: null,
  filters: []
};
